import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { FetchContext } from 'context/FetchContext';

function useDeletePodcast() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (podcastId) => {
      return privateFetch.delete(`/v1/admin/podcast/${podcastId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['podcasts']);
    },
    onError: (error) => {
      console.error('Delete Error:', error?.response?.data || error.message);
    },
  });
}

export default useDeletePodcast;
